import type { AuthState } from 'react-oidc-context'
import { create } from 'zustand'

export type AuthStoreState = {
  auth: AuthState | null
  isAuthenticated: boolean
  isLoading: boolean
  loginUser: () => void
  logoutUser: () => void
  _sync: (patch: Partial<Omit<AuthStoreState, '_sync'>>) => void
}

export const useAuthStore = create<AuthStoreState>(set => ({
  auth: null,
  isAuthenticated: false,
  isLoading: false,
  loginUser: () => {},
  logoutUser: () => {},
  _sync: patch => set(patch)
}))
